export const modelTypes = {
  Category: 'category',
  Collection: 'collection',
  Cycle: 'cycle',
}
